import angular from 'angular';
import appConfig from '../ConfigModule/ConfigModule';

/**
 * Module for auth actions.
 * @namespace cms.auth
 */
export default angular.module('cms.auth', [
    appConfig
]).factory('CMSAuthService', function (CONFIG, $http, localStorageService, $timeout) {
    /** @ngInclude */

    let service = {};


    /**
     * Login action.
     * Get auth token from backend.
     * @param string username
     * @param string password
     */
    service.login = function (username, password) {

        return $http.post(CONFIG.API_URL + "/login_check", {
            _username: username,
            _password: password
        }, {ignoreAuthModule: true, timeout: 20000}).then(function onSuccess(response) {

            localStorageService.set('user', response.data);
            localStorageService.set('invalidate-login', {invalidate: false});
            service.setHttpAuth();
            return {
                success: true,
                response: response
            };
        }, function onError(response) {
            return {
                success: false,
                response: response
            };
        });

    };

    /**
     * Login using only password.
     * User fetched from storage
     * @param string password
     */
    service.reLogin = function (password) {
        return service.login(service.getUser().username, password);
    };

    /**
     * Logout - remove user from storage and http headers
     * @param function callback
     */
    service.logout = (callback) => {
        localStorageService.remove('user');
        $http.defaults.headers.common.Authorization = '';
        if (callback) {
            callback();
        }
    };

    service.resetPasswordRequest = (email) => {
        return $http.post(CONFIG.API_URL + "/resetPasswordRequest", {
            email: email
        });
    };

    service.resetPassword = (token, password, passwordRepeat) => {
        return $http.post(CONFIG.API_URL + "/resetPassword", {
            token: token,
            plainPassword: password,
            plainPasswordRepeat: passwordRepeat
        });
    };

    /**
     * Add auth token to http requests
     */
    service.setHttpAuth = function () {
        if (service.getToken()) {
            $http.defaults.headers.common.Authorization = "JWT " + service.getToken();
        }
    };

    /**
     * Get user data from localstorage
     */
    service.getUser = function () {
        if (localStorageService.get('user')) {
            return localStorageService.get('user').data;
        }
    };

    /**
     * Save user data to localstorage
     * @param userData
     */
    service.setUser = function(userData) {
        let storedUser = localStorageService.get('user');
        storedUser.data = userData;
        localStorageService.set('user', storedUser);
    };

    /**
     * Get token from localstorage
     */
    service.getToken = function () {
        if (localStorageService.get('user')) {
            return localStorageService.get('user').token;
        }
    };

    /**
     * Get invalidateLogin from localstorage
     */
    service.getInvalidateLogin = function () {
        if (localStorageService.get('invalidate-login')) {
            return localStorageService.get('invalidate-login').invalidate;
        }
    };

    return service;

}).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Auth/CMSAuthService.js